import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LeadsmeetingRoutingModule } from './leadsmeeting-routing.module';
import { LeadsmeetingComponent } from './leadsmeeting.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CustomExcelMapperModule } from 'src/app/shared/custom-excel-mapper/custom-excel-mapper.module';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    LeadsmeetingComponent
  ],
  imports: [
    CommonModule,
    LeadsmeetingRoutingModule,
    SharedModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    MatDatepickerModule,
    CustomExcelMapperModule,
    MatFormFieldModule,
    MatAutocompleteModule
  ],
  exports:[LeadsmeetingComponent]
})
export class LeadsmeetingModule { }
